import React from "react";
import SeoHead from "../components/SeoHead";

export default function TermsConditions() {
  return (
    <div>
      <SeoHead
        title="Terms & Conditions — Hand & Wrist Clinics"
        description="Terms and Conditions for using the Hand & Wrist Clinics website."
        url="https://www.handandwristclinics.com/terms"
      />

      <header className="ab-hero" style={{ minHeight: "260px" }}>
        <div className="ab-hero-inner">
          <nav className="ab-breadcrumb" aria-label="Breadcrumb">
            <a href="/">Home</a>
            <span className="ab-bc-sep">/</span>
            <span className="ab-bc-current">Terms &amp; Conditions</span>
          </nav>
          <div className="ab-eyebrow"><span></span> Legal</div>
          <h1 className="ab-title">Terms &amp; <em>Conditions</em></h1>
          <div className="ab-divider" />
          <p className="ab-hero-sub">Please read these terms carefully before using our website.</p>
        </div>
      </header>

      <section className="section section-cream">
        <div className="container" style={{ maxWidth: "820px" }}>

          <div className="pp-meta">
            <span><strong>Effective Date:</strong> [Insert Date]</span>
          </div>

          <p className="pp-intro">
            By accessing and using the Hand &amp; Wrist Clinics website (
            <a href="https://www.handandwristclinics.com" className="pp-link">www.handandwristclinics.com</a>
            ), you agree to the following Terms &amp; Conditions.
          </p>

          {[
            {
              num: "1",
              title: "Website Information",
              body: "The information provided on this Website is intended to provide information about Hand & Wrist Clinics, our doctor, services, treatments, and facilities. We make reasonable efforts to keep the information accurate and up to date. However, information such as doctor availability, services, timings, and appointments may change without prior notice."
            },
            {
              num: "2",
              title: "Appointments and Enquiries",
              body: "Users may contact Hand & Wrist Clinics through WhatsApp for enquiries and appointment requests. Contacting us through WhatsApp does not guarantee an appointment. Appointments are subject to availability and confirmation by the Clinic."
            },
            {
              num: "3",
              title: "Medical Services",
              body: "Information available on this Website does not replace consultation with a qualified healthcare professional. Medical advice, diagnosis, and treatment will be provided based on an individual consultation with the appropriate healthcare professional."
            },
            {
              num: "4",
              title: "Website Security",
              body: "We make reasonable efforts to keep the Website available and functioning properly. However, we do not guarantee uninterrupted or error-free access to the Website."
            },
            {
              num: "5",
              title: "Changes to These Terms",
              body: "We may update these Terms & Conditions from time to time. Any changes will be posted on this page."
            },
          ].map((s) => (
            <div className="pp-section" key={s.num}>
              <h2 className="pp-heading">{s.num}. {s.title}</h2>
              <p className="pp-text">{s.body}</p>
            </div>
          ))}

          <div className="pp-section pp-contact-box">
            <h2 className="pp-heading">6. Contact Us</h2>
            <p className="pp-text">If you have any questions regarding these Terms &amp; Conditions, please contact us:</p>
            <div className="pp-contact-details">
              <p><strong>Hand &amp; Wrist Clinics</strong></p>
              <p>Email: <a href="mailto:handandwristclinics@gmail.com" className="pp-link">handandwristclinics@gmail.com</a></p>
              <p>Phone: <a href="tel:+919573152875" className="pp-link">+91 9573152875</a></p>
            </div>
          </div>

        </div>
      </section>

      <style>{`
        .pp-meta {
          display: flex; gap: 24px; flex-wrap: wrap;
          font-size: 0.82rem; color: var(--muted);
          margin-bottom: 28px; padding-bottom: 20px;
          border-bottom: 1px solid var(--border);
        }
        .pp-intro {
          font-size: 0.97rem; color: var(--text); line-height: 1.8;
          margin-bottom: 16px;
        }
        .pp-section {
          margin-top: 40px; padding-top: 32px;
          border-top: 1px solid var(--border);
        }
        .pp-heading {
          font-family: 'Cormorant Garamond', serif;
          font-size: 1.45rem; font-weight: 700;
          color: var(--navy); margin-bottom: 14px;
        }
        .pp-text {
          font-size: 0.92rem; color: var(--text);
          line-height: 1.8; margin-bottom: 12px;
        }
        .pp-link {
          color: var(--indigo); text-decoration: none; font-weight: 500;
        }
        .pp-link:hover { text-decoration: underline; }
        .pp-contact-box {
          background: white; border-radius: 16px;
          padding: 32px; border: 1.5px solid var(--border);
          box-shadow: var(--shadow-sm);
        }
        .pp-contact-details {
          display: grid; gap: 8px; margin-top: 16px;
        }
        .pp-contact-details p {
          font-size: 0.92rem; color: var(--text); line-height: 1.7;
        }
      `}</style>
    </div>
  );
}
